"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _inputOnBlur = _interopRequireDefault(require("../../../../../core/input-on-blur"));
var _selectMultiCode = _interopRequireDefault(require("../../../../../core/select-multi-code"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Note - not using editable multi-select here because the EditRTCsForm is also used within edit-entry-form
var _ref = /*#__PURE__*/_react.default.createElement("h5", null, "Notes:");
class EditRTCsForm extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_setRTC", (refCode, value) => {
      if (value) {
        this.props.onCreateRTC(this.props.entry.id, refCode);
      } else {
        this.props.onRemoveRTC(this.props.entry.id, refCode);
      }
    });
  }
  render() {
    const entry = this.props.entry;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_selectMultiCode.default, {
      lookup: "RefCodes",
      codeType: "rtc",
      name: "entryRTC",
      colSize: 6,
      selectedCodes: entry.rtcRefs,
      onChange: this._setRTC
    }), _ref, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      enabled: true,
      type: "TextArea",
      name: "rtcNotes",
      value: entry.rtcNotes,
      maxLength: 200,
      onChange: value => this.props.onUpdateEntry(entry.id, 'rtcNotes', value)
    }));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(EditRTCsForm, "partialQueries", {
  Entry: {
    id: true,
    rtcRefs: true,
    rtcNotes: true
  }
});
var _ref2 = {
  "refCodes(codeType:\"rtc\")": {
    id: true,
    refCode: true,
    description: true,
    isExpired: true
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(EditRTCsForm, props => _ref2, (client, props) => ({
  onUpdateEntry(id, field, value) {
    return client.update('Entry.set', {
      id,
      field,
      value
    });
  },
  onCreateRTC(entryID, rtcRef) {
    return client.update('Entry.createRTC', {
      entryID,
      rtcRef
    });
  },
  onRemoveRTC(entryID, rtcRef) {
    return client.update('Entry.removeRTC', {
      entryID,
      rtcRef
    });
  }
}));